import React from 'react';
import { RiskMenuContainer } from './style';
import LinkContextMenu from 'routes/surface/components/link-context-menu';
// import {
//   useLinkMenuPosition,
//   useSelectedLink,
// } from 'state/canvas/selected-link';
import { useCanvasStageScale } from 'state/canvas/stage';
import useCanvasLoading from 'components/canvas/hooks/use-canvas-loading';
import { useSpring } from 'react-spring';
import { useRiskMenuPosition } from 'state/canvas/selected-risk';
import RiskContextMenu from 'routes/surface/components/risks-context-menu';
import { useQuery } from '@apollo/client';
import { surfaceNodeQuery } from 'graphql/surface-node/queries/surface-node';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { da } from 'date-fns/locale';

export interface RsikContextMenuProps {}

const defaultProps = {};

function SurfaceRiskContextMenu() {
  // const [link] = useSelectedLink();

  const [riskMenuPosition] = useRiskMenuPosition();

  console.log('XXXX ', riskMenuPosition);

  const scale = useCanvasStageScale();

  const { isLoading } = useCanvasLoading();

  const isVisible = riskMenuPosition;

  const { getSelectedNode } = useSelectedNodeOperations();

  const node = getSelectedNode();

  const { data } = useQuery(surfaceNodeQuery, {
    variables: { id: node },
    // fetchPolicy: 'cache-only',
    skip: !riskMenuPosition,
  });

  console.log('XXXX ', riskMenuPosition, data, node);

  if (isLoading) {
    return null;
  }

  if (!data) {
    return null;
  }
  // console.log('RISK CONTEXT MENU ', riskMenuPosition, getSelectedNode());

  return (
    <RiskMenuContainer isVisible={isVisible}>
      {/* {isVisible && <div>XXXXX</div>} */}
      {isVisible && (
        <RiskContextMenu
          position={riskMenuPosition}
          scale={scale}
          node={data.surfaceNode.data}

          // link={link as any}
        />
      )}
    </RiskMenuContainer>
  );
}

SurfaceRiskContextMenu.defaultProps = defaultProps;

export default SurfaceRiskContextMenu;
